<template>
  <div>
    <BarChart v-if="loaded" :chartdata="chartdata" :options="options" />
  </div>
</template>
<script>
import BarChart from "./chart-main.vue";
import "chartjs-plugin-datalabels";

export default {
  name: "PuntajeMaximo",
  components: {
    BarChart
  },
  props: {
    resultados: {
      type: Array
    }
  },
  data: () => ({
    chartdata: {
      labels: [],
      datasets: [
        {
          minBarLength: 2,
          label: "Tu puntuacion",
          backgroundColor: "#583C89",
          data: []
        },
        {
          minBarLength: 2,
          label: "puntuacion Maxima",
          backgroundColor: "#FEC32B",
          data: []
        }
      ]
    },
    loaded: false,
    options: {
      plugins: {
        datalabels: {
          formatter: function(value) {
            return value + " pts";
          },
          // rotation: -90,
          color: "black",
          anchor: "end",
          align: "top",
          font: {
            size: "17",
            weight: "bold"
          }
        }
      },
      legend: {
        display: false
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              //                                drawBorder: true,
              lineWidth: 2,
              color: "#8D8E8E",
              drawBorder: false,
              zeroLineWidth: 3,
              zeroLineColor: "#555555"
            },
            ticks: {
              fontStyle: "bold",
              fontSize: 13,
              fontColor: "#808080"
            }
          }
        ],
        yAxes: [
          {
            gridLines: {
              display: true,
              //                                drawBorder: true,
              lineWidth: 2,
              color: "#9D9D9C",
              drawBorder: false,
              zeroLineWidth: 3,
              zeroLineColor: "#555555"
            },
            ticks: {
              fontStyle: "bold",
              fontSize: 13,
              fontColor: "#626366",
              beginAtZero: true,
              min: 0,
              stepSize: 30
            }
          }
        ]
      },
      responsive: true,
      maintainAspectRatio: false
    }
  }),
  created() {},
  mounted() {
    this.getPuntajeMaximo();
  },
  methods: {
    getPuntajeMaximo() {
      console.log("Aqui resultados", this.resultados);
      this.loaded = false;
      let data = {
        key: localStorage.getItem("keys"),
        id_estudiante: localStorage.getItem("id_estudiante")
      };
      this.$store
        .dispatch("getPuntajeMaximo", data)
        .then(response => {
          console.log(response.data.maximo["mio"]);
          for (let i = 0; i < response.data.maximo["mio"].length; i++) {
            this.chartdata.labels.push(response.data.maximo["mio"][i].titulo);
            this.chartdata.datasets[0].data.push(
              response.data.maximo["mio"][i].maximo
            );
            for (let x = 0; x < response.data.maximo["otro"].length; x++) {
              if (
                response.data.maximo["mio"][i].id_modulo ==
                response.data.maximo["otro"][x].id_modulo
              ) {
                this.chartdata.datasets[1].data.push(
                  response.data.maximo["otro"][x].maximo
                );
              } else {
                this.chartdata.datasets[1].data.push("0");
              }
            }
          }
          this.loaded = true;
        })
        .catch(error => {
          console.log(error.message);
        });
    }
  }
};
</script>